module.exports = __webpack_public_path__ + "img/a2.fc635133.jpg";